import { ContentChunkFragment } from '@/integrations/crystallize/__gql-codegen-types/catalogue/graphql';
import ButtonLink from '@/ui/components/shared/ButtonLink';
import { RichTextRenderer } from '@/ui/components/tileRenderers/RichTextRenderer';
import { extractComponentFromChunk } from '@/ui/utils/tiles';
import React from 'react';

export default function IsCompatibleScreen({
  chunk,
  trackingPrefix,
}: Readonly<{
  chunk: ContentChunkFragment;
  trackingPrefix?: string;
}>) {
  const isCompatibleScreenChunk = chunk.chunks?.[0];
  const title = extractComponentFromChunk(
    isCompatibleScreenChunk,
    'title',
    'SingleLineContent',
  )?.text;
  const description = extractComponentFromChunk(
    isCompatibleScreenChunk,
    'description',
    'RichTextContent',
  );
  const cta = extractComponentFromChunk(isCompatibleScreenChunk, 'cta', 'PieceContent');

  return (
    <div>
      <h2 className="mb-2 text-2xl font-bold">{title}</h2>
      <RichTextRenderer blocks={description} />
      <ButtonLink
        ctaComponent={cta}
        className="mx-auto mt-4 w-fit"
        trackingPrefix={trackingPrefix}
      />
    </div>
  );
}
